import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TableWithCustomSearch from "../../../../components/table/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import { calculateTotals, cuFormat } from "../../../../components/table/coreUiTable/Format";

const LifetimeTable = () => {
  let {
    table: { table_data, table_headers = [], raw_data_link, table_data_types, total_calculations },
    table
  } = useSelector((state) => state.lifetimeValueByMembership);

  const [totalWidths, setTotalWidths] = useState([]);
  const [tableStyles, setTableStyles] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [totalsToExport, setTotalsToExport] = useState([]);
  const [showTotals, setShowTotals] = useState(table.table_data.length > 0);
  const [colValues, setColValues] = useState([]);
  const children = document
    .getElementById("lifetimeValueByMembershipType")
    ?.querySelector("tr")?.children;

  const updateTotalRowWidth = () => {
    // if rendered get children's widths on each filter (render)
    if (!filteredData.length) return;
    if (children) {
      const newtWidths = [];
      for (let i = 0; i < children.length; i++) {
        const rect = children[i].getBoundingClientRect();
        //This logic is needed to keep the maximum width of the first page columns
        if (i >= 1 && totalWidths[i] > rect.width) {
          newtWidths.push(totalWidths[i]);
        } else {
          newtWidths.push(rect.width);
        }
      }
      setTotalWidths(newtWidths);
    }
  };

  useEffect(() => {
    setShowTotals(filteredData.length > 0);
    updateTotalRowWidth();
  }, [filteredData]);

  const formattedSlots = cuFormat({
    headers: table_headers,
    columns: table_data_types.map((col) => {
      if (col.type === "numeric") {
        return { ...col, format: { ...col.format, mantissa: 0 } };
      }
      return col;
    }),
    links: raw_data_link
  });

  const changeTotalRowWidth = () => {
    setTimeout(() => updateTotalRowWidth(), 0);
  };

  useEffect(() => {
    const totals = ["Totals"];
    const colValuesArray = table_headers.slice(1, 6).map((header, index) => {
      const value = calculateTotals(
        filteredData,
        total_calculations[index + 2],
        table_headers,
        header
      );
      totals.push(value);
      return value;
    });

    setTotalsToExport(totals);
    setColValues(colValuesArray);
  }, [filteredData, total_calculations, table_headers]);

  useEffect(() => {
    generateStyles(totalWidths);
  }, [totalWidths]);

  const generateStyles = (totalWidths) => {
    //Generate styles with the maximum width of the first page columns
    const styles = totalWidths
      .map(
        (elem, idx) =>
          `#lifetimeValueByMembershipType tr td:nth-child(${idx + 1}){min-width: ${elem}px;}`
      )
      .join(" ");

    return setTableStyles(styles);
  };

  return (
    <>
      <TableWithCustomSearch
        data={table_data}
        colHeaders={table_headers}
        columns={table_data_types}
        rawDataLink={raw_data_link}
        tableWrapperId="lifetimeValueByMembershipType"
        fileName="Lifetime-Value"
        dateConversion={false}
        additionalDataToExport={totalsToExport}
        onFilteredItemsChange={(data) => setFilteredData(data)}
        onPageChange={changeTotalRowWidth}
        customFn={(header, formattedValue) => {
          if (header === "Membership Type") {
            return (
              <div title={formattedValue}>
                {formattedValue.length > 22
                  ? formattedValue.substring(0, 22) + "..."
                  : formattedValue}
              </div>
            );
          }
          return formattedValue;
        }}
        underTableSlot={
          showTotals ? (
            <>
              <table className="table coreUiTable" id="under-table-slot">
                <tbody>
                  <tr>
                    <td style={{ minWidth: `${totalWidths[0]}px` }}></td>
                    <td style={{ fontWeight: "700", minWidth: `${totalWidths[1]}px` }}>Total</td>
                    {table_headers.slice(1, 6).map((header, index) => {
                      const renderFunc = formattedSlots[header];
                      const tdStyle = { minWidth: `${totalWidths[index + 2]}px` };

                      const value = {
                        [header]: colValues[index]
                      };
                      return renderFunc(value, tdStyle);
                    })}
                    <td style={{ minWidth: `${totalWidths[7]}px` }}></td>
                    <td style={{ minWidth: `${totalWidths[8]}px` }}></td>
                  </tr>
                </tbody>
              </table>
            </>
          ) : null
        }
      />
      <style type="text/css">{tableStyles}</style>
    </>
  );
};

export default LifetimeTable;
